import { render } from "./FormWithHeaderAndFooter.vue?vue&type=template&id=7508a974"
import script from "./FormWithHeaderAndFooter.vue?vue&type=script&lang=js"
export * from "./FormWithHeaderAndFooter.vue?vue&type=script&lang=js"

import "./FormWithHeaderAndFooter.vue?vue&type=style&index=0&id=7508a974&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__